/**
 * VideoCallRole enum
 *
 * The Agora client role used for the 1:1 chat video call. This string is the
 * wire `role` payload sent to the `generateLiveStreamToken` Cloud Function
 * (see `cloudFunctionsService.generateLiveStreamToken`), so the value must
 * match Flutter exactly.
 *
 * Flutter passes `ClientRoleType.clientRoleBroadcaster.name` as the role
 * (lib/presentation/screens/chat/video_call_screen.dart:527). In Dart,
 * `Enum.name` returns the declared identifier verbatim, so the wire value is
 * the string `"clientRoleBroadcaster"` (agora_rtc_engine
 * lib/src/agora_base.dart `enum ClientRoleType { clientRoleBroadcaster, ... }`).
 *
 * Both endpoints (caller and audience) join as broadcaster
 * (video_call_screen.dart:212 sets `ClientRoleType.clientRoleBroadcaster` for
 * both via `setClientRole`).
 */
export enum VideoCallRole {
  /**
   * Host / broadcaster — can both send and receive streams.
   * Wire value matches `ClientRoleType.clientRoleBroadcaster.name` in Flutter.
   *
   * NOTE: this string is the *token* `role` payload, NOT the local Agora client
   * role. The CF maps it via `data.role.toUpperCase() === "BROADCASTER"`
   * (cloud_functions/functions/src/functions/live_streaming/live_streaming.ts:22);
   * `"clientRoleBroadcaster"` is not the literal `"BROADCASTER"`, so the issued
   * token is `RtcRole.SUBSCRIBER`. The "broadcaster" semantic refers to the
   * local `setClientRole` call (video_call_screen.dart:212), not the issued
   * token. This mirrors Flutter exactly — do not change the value.
   */
  broadcaster = 'clientRoleBroadcaster',
}
